export default "__VITE_ASSET__B8R1fUB1__"